import styled from 'styled-components'
import { GRAYSCALE_500, GRAYSCALE_600 } from '../../styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

interface PriceTextProps {
  $fontFamily: string
  $fontSize: number
}

export const IdrPrice = styled.span<PriceTextProps>`
  font-family: ${props => props.$fontFamily};
  font-size: ${props => props.$fontSize}px;
  color: ${GRAYSCALE_600};
`

export const JidrPrice = styled.span<PriceTextProps>`
  font-family: ${props => props.$fontFamily};
  font-size: ${props => props.$fontSize}px;
  color: ${GRAYSCALE_500};
`
